module.exports = __webpack_public_path__ + "static/media/DBHeaventNow.aa452058.woff";